// @ts-nocheck
/* eslint-disable */
export const backIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.444 11.757"><path fill="#4567ca" d="M13.05 11.757a.394.394 0 0 1-.388-.329 5.97 5.97 0 0 0-5.968-4.725v2.129a.394.394 0 0 1-.623.32L.165 4.933a.394.394 0 0 1 0-.641L6.071.073a.394.394 0 0 1 .623.321v2.161c2.52.251 6.75 2.07 6.75 8.807a.394.394 0 0 1-.361.393Z" data-name="Path 6498"/></svg>`,
    name: 'back' as const
};